/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Persona4Inputs */

const zh_landing_audience_persona4 = /** @type {(inputs: Landing_Audience_Persona4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习方式不同的学生`)
};

const en_landing_audience_persona4 = /** @type {(inputs: Landing_Audience_Persona4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neurodiverse Learners`)
};

const es_landing_audience_persona4 = /** @type {(inputs: Landing_Audience_Persona4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprendices neurodivergentes`)
};

/**
* | output |
* | --- |
* | "Neurodiverse Learners" |
*
* @param {Landing_Audience_Persona4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_persona4 = /** @type {((inputs?: Landing_Audience_Persona4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Persona4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_persona4(inputs)
	if (locale === "en") return en_landing_audience_persona4(inputs)
	return es_landing_audience_persona4(inputs)
});